<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/ADC4/ADC4.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">ADC3.0 驾驶域控制器</div>
                <div class="detail-banner-desc">液冷散热。</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            双电源冗余：域控双电源内部要求独立的隔离和诊断主电源供电， 出现任何主电源切断，都需要无任何延时的保障系统供电，以满足L2系统断电存储的要求
                        </div>
                        <div>
                            安全启动：SOC安全启动，系统启动时对SOC侧镜像文件进行验签，验签通过后才可挂载和运行
                        </div>
                        <div>
                            存储要求：支持用户分区定制化与磁盘分区调整；支持系统分区划分
                        </div>
                        <div>
                            功耗管理：支持运行模式、待机模式、低功耗模式（MCU on，SOC off）、浅休眠模式（MCU on，SOC休眠）、一键低功耗、哨兵模式、局部网络管理
                        </div>
                        <div>
                            机壳：水冷板和下盖为压铸铝合金材质
                        </div>
                        <div>
                            散热方式：水冷散热，耐水冷液体65℃
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">9V～16V</div>
                                    <div class="k">工作电压</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤220W</div>
                                    <div class="k">额定功率（常温23°C）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤384W</div>
                                    <div class="k">峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤15A</div>
                                    <div class="k">额定电流（12V）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤0.5mA</div>
                                    <div class="k">静态电流</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">-40℃~85℃</div>
                                    <div class="k">工作温度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">-40℃~95℃</div>
                                    <div class="k">存放温度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">IP52</div>
                                    <div class="k">防护等级</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">＜2Kg</div>
                                    <div class="k">重量</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">256.5 X 230 X 44</div>
                                    <div class="k">全尺寸(mm)</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">209 X 220 X 38</div>
                                    <div class="k">本体尺寸(mm)</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">出图/进功能：250ms</div>
                                    <div class="k">热启动时间</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">出图：250ms，进功能：6s启动时间</div>
                                    <div class="k">冷启动时间</div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">1.0 cm+1 ppm（RMS）</div>
                                    <div class="k">RTK 精度：水平</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1.5 cm+1 ppm（RMS）</div>
                                    <div class="k">RTK 精度：高程</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">标度误差2‰，三轴正交耦合误差，0.9‰ (0.05°)</div>
                                    <div class="k">IMU性能指标</div>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'ADC3.0 驾驶域控制器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/ADC3-2.html'
};

import { createApp } from 'vue';
import App from './ADC3-2.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./ADC3-2.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
